import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

import bgSrc from './assets/Ellipse810.png'

export const modal = css`
  inline-size: 470px;
  block-size: 800px;
  max-block-size: calc(100% - 48px);
  background-image: url(${bgSrc});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-color: ${cssTheme.default.day.backgroundInvert};
  /* Переопределен цвет крестика закрытия модалки */
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
`
export const header = css`
  margin: 40px 48px 16px 18px;
`
export const body = css`
  margin: 0 48px 16px 24px;
  background-color: transparent;
  background-image: none;
`
export const image = css`
  flex: 1;
  background-position: center;
  background-repeat: no-repeat;
`

export const footer = css`
  background-color: transparent;
`
